//@ts-nocheck
import { getConfig } from "../../config/config";
import { REACT_APP_API_HEADER_KEY, REACT_MARKET_DEPTH_KEY, CLIENTCID_Depth } from "../../utils/constant";
import { decryptEnv } from "../../helpers";
const { APP_BASE_API_URL, APP_BASE_SWARAJ_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, APP_HEAD_REQUEST_CODE, APP_USER_ID, APP_PASSWORD, } = getConfig();
export const getSIPReturns = (exch, symbol) => {
    const url = `${APP_BASE_API_URL}company-performance/${exch}/-/-/-/${encodeURIComponent(symbol)}?responsetype=json`;
    const headers = new Headers();
    headers.append("authorization", `Basic ${decryptEnv(REACT_MARKET_DEPTH_KEY)}`);
    headers.append("appname", "5PTRADE");
    headers.append("clientid", decryptEnv(CLIENTCID_Depth));
    headers.append("ocp-apim-subscription-key", `${decryptEnv(APP_OCP_APIM_KEY)}`);
    return fetch(url, {
        method: "GET",
        headers: headers,
        credentials: "include"
    })
        .then((res) => {
        if (!res.ok)
            throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
    })
        .catch((err) => {
        console.error("Error fetching stock performance:", err);
        throw err;
    });
};
export const getFutOptStockDetails = (scripCode) => {
    const headers = {
        'appname': '5PTRADE',
        'authorization': `Basic ${decryptEnv(REACT_MARKET_DEPTH_KEY)}`,
        'clientid': decryptEnv(CLIENTCID_Depth),
        'ocp-apim-subscription-key': `${decryptEnv(APP_OCP_APIM_KEY)}`,
    };
    const endpoint = `${APP_BASE_API_URL}tradeapi/futoptindvidualstockdetail-version2/${scripCode}/-/-/-/0/-?responsetype=json`;
    return fetch(endpoint, {
        method: 'GET',
        headers: headers,
        credentials: 'include'
    })
        .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    });
};
export async function getCashFilterData(symbol) {
    try {
        const exchange = symbol.split(":")[0].charAt(0);
        const exchType = symbol.split("-")[1];
        const scripCode = symbol.split("/")[1].split("-")[0];
        const raw = {
            head: {
                appName: "5PTRADE",
                appSource: "23",
                appVer: "1.0",
                key: decryptEnv(REACT_APP_API_HEADER_KEY),
                osName: "Web",
                requestCode: "5PCashFilterV3"
            },
            body: [
                {
                    Exch: exchange,
                    ExchType: exchType,
                    ScripCode: scripCode
                }
            ]
        };
        const response = await fetch(`${APP_BASE_SWARAJ_API_URL}V3/CashFilter`, {
            method: "POST",
            headers: {
                "Password": "H98qlU4Sn2",
                "UserID": "ZyT47UW2g56",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(raw)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Error in getCashFilterData:", error);
        throw error;
    }
}
export const getIndicesList = async (exchange) => {
    var _a;
    const token = `Bearer ${(_a = localStorage.getItem("JWTToken")) === null || _a === void 0 ? void 0 : _a.replace("JWTToken", "")}`;
    const headers = {
        "Content-Type": "application/json",
        "Authorization": token,
        "Ocp-Apim-Subscription-Key": decryptEnv(APP_OCP_APIM_KEY),
    };
    const payload = {
        Count: 0,
        Exch: exchange,
        ClientLoginType: 0,
        LastRequestTime: "/Date(0)/",
        RefreshRate: "H",
    };
    try {
        const fetchOptions = {
            method: "POST",
            credentials: "include",
            headers,
            body: JSON.stringify(payload),
        };
        const response = await fetch(`${APP_BASE_API_URL}tradeapi/IndicesV3`, fetchOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        if (error.name !== "AbortError") {
            console.error("Error fetching indices:", error);
        }
        throw error;
    }
};
